"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = exports.IconNameArray = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var anvil_icons_1 = require("@servicetitan/anvil-icons");
Object.defineProperty(exports, "IconNameArray", { enumerable: true, get: function () { return anvil_icons_1.IconNameArray; } });
var Icon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentColor' : _b, className = _a.className, _c = _a.el, IconElement = _c === void 0 ? 'i' : _c, name = _a.name, _d = _a.size, size = _d === void 0 ? '1em' : _d, props = __rest(_a, ["color", "className", "el", "name", "size"]);
    if (!name) {
        console.warn('No name prop passed to Icon');
        return null;
    }
    var _e = anvil_icons_1.getIconByName(name), viewbox = _e.viewbox, content = _e.content;
    if (!content) {
        console.warn('Icon does not exist', name);
        return null;
    }
    var IconClasses = classnames_1.default('a-Icon', "a-Icon--" + name, className);
    return (react_1.default.createElement(IconElement, __assign({ className: IconClasses, width: size, height: size }, props),
        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: color, height: size, width: size, viewBox: viewbox, 
            /* eslint-disable react/no-danger */
            dangerouslySetInnerHTML: { __html: content } })));
};
exports.Icon = Icon;
exports.Icon.displayName = 'Icon';
//# sourceMappingURL=Icon.js.map